var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "doc",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.502,
    height: 18.054,
    viewBox: "0 0 13.502 18.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_4_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M102.108,0h6.041l5.113,5.335v10.37a2.348,2.348,0,0,1-2.349,2.349h-8.805a2.348,2.348,0,0,1-2.349-2.349V2.349A2.348,2.348,0,0,1,102.108,0Z",
    transform: "translate(-99.759 0)",
    fill: "#0263d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(2.181 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M467.212,0V5.291h5.121Z",
    transform: "translate(-461.011)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M195.356,435.239V432.25h1.059a1.93,1.93,0,0,1,.591.09,1.626,1.626,0,0,1,.5.265,1.186,1.186,0,0,1,.35.467,1.814,1.814,0,0,1,0,1.343,1.185,1.185,0,0,1-.35.467,1.627,1.627,0,0,1-.5.265,1.93,1.93,0,0,1-.591.09Zm.747-.65h.221a1.283,1.283,0,0,0,.331-.041.945.945,0,0,0,.282-.136.592.592,0,0,0,.2-.263.973.973,0,0,0,.075-.4.994.994,0,0,0-.075-.406.6.6,0,0,0-.2-.26.892.892,0,0,0-.282-.136,1.283,1.283,0,0,0-.331-.041H196.1Zm3.692.684a1.529,1.529,0,0,1-1.117-.436,1.576,1.576,0,0,1,0-2.185,1.528,1.528,0,0,1,1.117-.436,1.512,1.512,0,0,1,1.1.436,1.582,1.582,0,0,1,0,2.185A1.512,1.512,0,0,1,199.8,435.273Zm-.574-.9a.775.775,0,0,0,1.137,0,1.008,1.008,0,0,0,0-1.261.775.775,0,0,0-1.137,0,1,1,0,0,0,0,1.261Zm3.894.9a1.533,1.533,0,0,1-1.085-.4,1.666,1.666,0,0,1,0-2.246,1.537,1.537,0,0,1,1.081-.406,1.519,1.519,0,0,1,.954.287,1.074,1.074,0,0,1,.428.759l-.754.153a.676.676,0,0,0-.224-.4.611.611,0,0,0-.409-.151.7.7,0,0,0-.535.229,1.084,1.084,0,0,0,0,1.3.7.7,0,0,0,.538.231.62.62,0,0,0,.4-.131.577.577,0,0,0,.207-.35l.771.175a1.134,1.134,0,0,1-.47.7A1.543,1.543,0,0,1,203.115,435.273Z",
    transform: "translate(-195.356 -422.357)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.9445e9550c2b7d0337c1ef866a294dbe.svg";
export { ForwardRef as ReactComponent };